import {ReactNode} from 'react';
import {useViewerEndQuery} from '../../../../../../wrapper/viewerWrapper';

export interface ViewerEndFetcherHeadlessProps {
  seriesId: number;
  productId: number;
  children: ReactNode;
}

export function ViewerEndFetcherHeadless({
  seriesId,
  productId,
  children,
}: ViewerEndFetcherHeadlessProps) {
  const {data} = useViewerEndQuery({
    seriesId,
    productId,
    apiPath: window?.KPApp?.getViewerEndPath?.(),
  });

  if (!children) {
    return null;
  }

  return <>{!!data && children}</>;
}
